import { formatDateOrdinal } from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { AppointmentProposalOption } from '../../../../data-access/appointmentProposalOptions';
import DocumentRow, { DocumentRowProps } from './DocumentRow';

interface OptionDocumentCardOption {
  appointmentProposalOptionId: string;
  name: string;
  status: AppointmentProposalOption['status'];
  acceptedDate: string;
  documents: DocumentRowProps[];
}

interface OptionDocumentCardProps {
  option: OptionDocumentCardOption;
}

const OptionDocumentCard: React.FC<OptionDocumentCardProps> = ({ option }) => (
  <FlexBox
    border={(theme) => `1px solid ${theme.palette.gray?.[300]}`}
    borderRadius={4}
    flexDirection="column"
  >
    <FlexBox flexDirection="column" p={2} gap={1}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
        {option.name}
      </Typography>
      <FlexBox alignItems="center" gap={1}>
        <Chip label="Accepted" color="softGreen" size="small" />
        <Typography variant="caption" color="text.secondary">
          {formatDateOrdinal(option.acceptedDate)}
        </Typography>
      </FlexBox>
    </FlexBox>
    <Divider />
    <FlexBox flexDirection="column" px={2}>
      {option.documents.map((file) => (
        <DocumentRow
          key={file.name}
          name={file.name}
          statusMessage={file.statusMessage}
          status={file.status}
          generatedAt={file.generatedAt}
          url={file.url}
          isGenerating={file.isGenerating}
          onGenerate={file.onGenerate}
        />
      ))}
    </FlexBox>
  </FlexBox>
);

export default OptionDocumentCard;
